import React from 'react'
import { Col, Row } from 'react-bootstrap'
import logo from '../../../public/assets/logo-primary.svg'
import styles from "./footer.module.css"
import email from '../../../public/assets/mail.png'
import hotline from '../../../public/assets/hotline.svg'
import { useMyContext } from '../../../myContext'

function Footer() {
  const {siteDisclaimerLink, partnerEmail, contactNumber} = useMyContext();
  return (
    <div style={{backgroundColor: "#0E0E0E", overflow: "hidden"}}>
      <div className={styles.outerRow}>
      <Row style={{width: "fit-content"}}><img src={logo} alt="logo" style={{height: "36px", marginBottom: "15px"}}></img></Row>
    <Row>
        <Col md={4}>
        <p className={styles.description}>©Borderless Softtech Pvt Ltd, a subsidiary of Borderless Investing Inc. {new Date().getFullYear()}</p>
        </Col>
        <Col md={8} className={styles.innerCol}>
        <Row style={{display: "flex", flexDirection: "column"}}>
            <p className={styles.parafirst}>Learn More</p>
            <a className={styles.parasecond} style={{textDecoration: "none", color: "white", cursor: "pointer"}}
            href={siteDisclaimerLink}
            target="_blank" rel="noopener noreferrer"> User Agreement</a>
            {/* <p className={styles.parasecond}>User Agreement</p> */}
        </Row>
        <Row style={{display: "flex", flexDirection: "column"}}>
            <p className={styles.parafirst}>Contact us</p>
            <p className={styles.parasecond}> <img src={email} className={styles.hotlineImage} alt="email" /> {partnerEmail}</p>
            <p className={styles.parasecond}> <img src={hotline} className={styles.hotlineImage} alt="phone" /> {contactNumber}</p>
        </Row>
        {/* <Row style={{display: "flex", flexDirection: "column"}}>
            <p className={styles.parafirst}>Follow Us</p>
            <p className={styles.imagePara} style={{padding: "0px"}}><img src={fb} alt="fb" /> <img src={twitter} alt="twitter" /> <img src={insta} alt="insta" /> <img src={linkedin} alt="linkedin" /></p>
        </Row> */}
        </Col>
    </Row>
    </div>
    <Row className={styles.bottomText}>
    Borderless Softtech Pvt Ltd, a subsidiary of Borderless Investing Inc. All Rights Reserved. | All Rights Reserved | Copyright © 2010 — {new Date().getFullYear()}
    </Row>
    </div>
  )
}

export default Footer